// extracted by mini-css-extract-plugin
module.exports = {"content":"StarSelector_content__3Gp4C","wrapper":"StarSelector_wrapper__Daltw"};